// extracted by mini-css-extract-plugin
export default {"avatar":"ModalBody_avatar__OA+o+","title":"ModalBody_title__PmB7L"};